const ANNOUNCE_STORE = {
  announceStore: 'Anunciar loja para entregadores',
  removeAnnouncement: 'Desligar anúncio para Entregadores ',
  announceStoreHexa: 'Divulgar loja',
  removeAnnouncementHexa: 'Desligar anúncio',
  announceStoreModal: {
    title: 'ANUNCIAR LOJA PARA ENTREGADORES',
    activateAnnouncementHexa: 'Ao ativar, sua loja será exibida no ',
    infoShared:
      'Vamos mostrar o nome da loja, endereço e telefone cadastrado. Isso pode te ajudar a receber mais entregas.',
    removeAnnouncement: 'Você pode desligar o anúncio quando quiser.',
    dataToShare: 'Dados a compartilhar',
    acceptDataSharingLabel:
      'Aceito compartilhar meus dados com pessoas entregadoras novas no App Zé Entregador',
    phoneListLabel: 'Selecione o telefone que quer compartilhar',
    selectPhonePlaceholder: 'Selecione um número',
    activateAnnouncement:
      'Ao ativar o anúncio de sua loja ela passa a ser exibida no ',
    cancel: 'Cancelar',
    close: 'Fechar',
    appZeEntregador: 'App Zé Entregador',
    newCouriers: ' para pessoas entregadoras novas da sua cidade.',
    storeDataInfo:
      'Será divulgado o nome da loja, endereço e telefone cadastrado. Isso poderá te ajudar a se conectar com mais pessoas para trabalhar.',
    canRemoveAnnouncement: 'A qualquer momento você poderá desligar o anúncio.',
    dataToBeShared: 'Dados a serem compartilhados',
    selectPhoneNumber: 'Selecione o telefone que deseja compartilhar',
    acceptDataSharing:
      'Eu aceito compartilhar meus dados com pessoas entregadoras novas no App Zé Entregador',
    announceStoreButton: 'Anunciar',
    selectYourPhoneNumber: 'Selecione o seu telefone',
    error: 'Houve um erro ao tentar anunciar a loja',
  },
  removeAnnouncementModal: {
    title: 'DESLIGAR ANÚNCIO DA LOJA PARA ENTREGADORES',
    areYouSure: 'Tem certeza que deseja desligar o anúncio da sua loja?',
    couriersWontFindStore:
      'Pessoas entregadoras novas no App Zé Entregador não poderão visualizar suas informações, isso dificulta que entregadores encontrem sua loja para trabalhar.',
    removeButton: 'Desligar Anúncio',
    error: 'Houve um erro ao tentar desligar o anúncio',
    titleHexa: 'Desligar anúncio da loja',
    areYouSureHexa: 'Tem certeza de que quer desligar o anúncio da sua loja?',
    couriersWontFindStoreHexa:
      'Pessoas entregadoras novas não vão conseguir ver suas informações. Isso pode dificultar que encontrem sua loja para trabalhar.',
    turnOffAnnouncement: 'Desligar',
    cancel: 'Cancelar',
    close: 'Fechar',
  },
  warningModal: {
    title: 'NÃO É POSSÍVEL ANUNCIAR SUA LOJA',
    youDontHave: 'Você não possui ',
    registeredPhone: 'nenhum telefone para contato cadastrado, ',
    toAnnounceStore:
      'para anunciar sua loja é necessário cadastrar um telefone. Para cadastrar seu telefone entre em contato ',
    contactViaChat: 'pelo Chat',
  },
  fleetManagementText: {
    announceStoreText: {
      announcementStore: 'Anunciar \n Minha Loja',
      removeAnnouncement: 'Desligar anuncio \n da loja',
    },
  },
}

export default ANNOUNCE_STORE
